import type * as React from 'react';

function SvgFacebookFooter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      height="1em"
      version="1.1"
      viewBox="0 0 40 40"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>icon_facebook-grey_40x40</title>
      <defs></defs>
      <g fill="none" fillRule="evenodd" id="Full-pages" stroke="none" strokeWidth="1">
        <g fill="currentColor" id="1280px-and-wider-(popular-desktop)" transform="translate(-828.000000, -2617.000000)">
          <g id="Group-2" transform="translate(-1.000000, 2304.000000)">
            <path
              d="M849,353 C837.954305,353 829,344.045695 829,333 C829,321.954305 837.954305,313 849,313 C860.045695,313 869,321.954305 869,333 C869,344.045695 860.045695,353 849,353 Z M854.355469,325.629721 L854.355469,322.004762 L851.35616,322 C848.388353,322 846.356457,323.811747 846.356457,327.138166 L846.356457,330.004507 L843,330.004507 L843,333.89174 L846.356457,333.89174 L846.356457,343.866237 L850.370798,343.866237 L850.370798,333.89174 L854.218471,333.89174 L854.219569,330.004507 L850.370798,330.004507 L850.370798,327.522787 C850.370798,326.397497 850.683623,325.630453 852.297198,325.630453 L854.355469,325.629721 Z"
              id="icon_facebook-grey_40x40"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgFacebookFooter;
